// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"5ba1c419","726":"510a70d0","787":"4a0b15f1"}[chunkId] + ".chunk.js";
};